import { Component, h, Host, Prop } from '@stencil/core';
import { ClassNames } from '../../../utils/interfaces';
import { TPatternlibIconBoldName } from '@/src/utils/generated/icons-link-bold';

@Component({
  tag: 'patternlib-icon-bold',
  styleUrl: 'patternlib-icon-bold.scss',
  shadow: true,
})
export class PatternlibIconBold {
  /**
   * Set an icon using the corresponding name from the bold icon font that is provided for the patternlib link only
   */
  @Prop() iconName: TPatternlibIconBoldName = 'download';

  /**
   * Set the width and height of the icon in px.
   */
  @Prop() size = '24px';

  /**
   * Define the fill color of the icon using a color variable.
   */
  @Prop() color?: string;

  @Prop() disabled = false;
  @Prop() variant: 'dark' | 'light' = 'light';

  /**
   * Define the display style of the host element.
   */
  @Prop() display = 'block';

  render() {
    const iconClass: ClassNames = {
      [`${'icon-liebherr-' + this.iconName + '-icon-12px'}`]: true,
      disabled: this.disabled,
      dark: this.variant == 'dark',
    };

    const iconStyle = {
      'fontSize': `${this.size}`,
      'color': this.color,
      'display': 'flex',
      'textAlign': 'center' as const,
      '--icon-name': `var(--patternlib-icon-liebherr-ui-${this.iconName}-icon-12px)`,
    };

    const renderIcon = <span class={iconClass} style={iconStyle}></span>;

    return <Host style={{ display: this.display }}>{renderIcon}</Host>;
  }
}
